let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("foiH8")).then(() => parcelRequire('cRUF7'));